import CrudManager from '@/components/admin/CrudManager';

const fields = [
    { key: 'sector_slug', label: 'Sector slug (unique)', type: 'text', placeholder: 'e.g. employment-services, health' },
    { key: 'sector_name', label: 'Sector name', type: 'text' },
    { key: 'tagline', label: 'Tagline', type: 'text' },
    { key: 'description', label: 'Brief description', type: 'textarea', rows: 3 },
    { key: 'activities', label: 'Activities completed', type: 'array', hint: 'Comma-separated bullets' },
    { key: 'stats', label: 'Achievement statistics', type: 'stats-list', hint: 'Label + value pairs shown as stat cards.' },
    { key: 'photo_gallery', label: 'Photo gallery', type: 'images-list', prefix: 'sector-achievements' },
    { key: 'supporting_content', label: 'Supporting content', type: 'rich-text' },
    { key: 'image_url', label: 'Hero image', type: 'upload-image', prefix: 'sector-achievements/hero' },
    { key: 'icon', label: 'Icon (lucide slug)', type: 'text' },
    { key: 'key_partners', label: 'Key partners (optional)', type: 'array', hint: 'Comma-separated' },
    { key: 'order', label: 'Order', type: 'number' },
];

const columns = [
    { key: 'sector_name', label: 'Sector', primary: true },
    { key: 'sector_slug', label: 'Slug' },
    { key: 'order', label: 'Order' },
];

const defaultItem = {
    sector_slug: '',
    sector_name: '',
    tagline: '',
    description: '',
    activities: [],
    stats: [],
    photo_gallery: [],
    supporting_content: '',
    image_url: '',
    icon: 'briefcase',
    key_partners: [],
    highlights: [],
    placements: '',
    employers: '',
    order: 99,
};

// Custom pre-save transformer for the stats JSON field.
export default function AdminSectorAchievementsPage() {
    return (
        <CrudManager
            resource="sector-achievements"
            title="Sector Achievements"
            description="7 sector sections on the Sector Achievements page. Includes rich supporting content and photo galleries."
            fields={fields}
            columns={columns}
            defaultItem={defaultItem}
            searchKeys={['sector_name', 'sector_slug']}
        />
    );
}
